module.exports = __webpack_public_path__ + "static/img/weather28.88af4bb1.png";